import mock from 'src/utils/mock';
import { PanelCategory as PanelCategoryInterface } from 'src/types/panelCategory';
const panelCategory: PanelCategoryInterface[] = [
    {
        RegLabID: 9001,
        SubCenterID: 1001,
        PanelCategID: 202,
        DisplayName: 'Biochemistry',
        Description: 'Biochemistry',
        Spl_Remarks: '',
        CreationDt: '2023-08-09T10:26:31.440Z',
        ValidFrom: '2023-08-09T10:26:31.440Z',
        ValidUpto: '2034-07-21T10:26:31.440Z',
        RevNo: 0,
    },
    {
        RegLabID: 9001,
        SubCenterID: 1001,
        PanelCategID: 204,
        DisplayName: 'Clinical Pathology',
        Description: 'Clinical Pathology',
        Spl_Remarks: '',
        CreationDt: '2023-08-09T10:26:31.440Z',
        ValidFrom: '2023-08-09T10:26:31.440Z',
        ValidUpto: '2034-07-21T10:26:31.440Z',
        RevNo: 0,
    },
    {
        RegLabID: 9001,
        SubCenterID: 1001,
        PanelCategID: 205,
        DisplayName: 'Cytology',
        Description: 'Cytology',
        Spl_Remarks: '',
        CreationDt: '2023-08-09T10:26:31.440Z',
        ValidFrom: '2023-08-09T10:26:31.440Z',
        ValidUpto: '2034-07-21T10:26:31.440Z',
        RevNo: 0,
    },
    {
        RegLabID: 9001,
        SubCenterID: 1001,
        PanelCategID: 207,
        DisplayName: 'Endocrinology',
        Description: 'Endocrinology',
        Spl_Remarks: '',
        CreationDt: '2023-08-09T10:26:31.440Z',
        ValidFrom: '2023-08-09T10:26:31.440Z',
        ValidUpto: '2034-07-21T10:26:31.440Z',
        RevNo: 0,
    },
    {
        RegLabID: 9001,
        SubCenterID: 1001,
        PanelCategID: 201,
        DisplayName: 'Haematology',
        Description: 'Haematology',
        Spl_Remarks: '',
        CreationDt: '2023-08-09T10:26:31.440Z',
        ValidFrom: '2023-08-09T10:26:31.440Z',
        ValidUpto: '2034-07-21T10:26:31.440Z',
        RevNo: 0,
    },
    {
        RegLabID: 9001,
        SubCenterID: 1001,
        PanelCategID: 206,
        DisplayName: 'Microbiology',
        Description: 'Microbiology',
        Spl_Remarks: '',
        CreationDt: '2023-08-09T10:26:31.440Z',
        ValidFrom: '2023-08-09T10:26:31.440Z',
        ValidUpto: '2034-07-21T10:26:31.440Z',
        RevNo: 0,
    },
    {
        RegLabID: 9001,
        SubCenterID: 1001,
        PanelCategID: 208,
        DisplayName: 'Miscellaneous',
        Description: 'Miscellaneous',
        Spl_Remarks: 'hi2x',
        CreationDt: '2023-08-09T10:26:31.440Z',
        ValidFrom: '2022-12-31T18:30:00.000Z',
        ValidUpto: '2060-12-11T18:30:00.000Z',
        RevNo: 16,
    },
    {
        RegLabID: 9001,
        SubCenterID: 1001,
        PanelCategID: 203,
        DisplayName: 'Serology & Immunology',
        Description: 'Serology & Immunology',
        Spl_Remarks: '',
        CreationDt: '2023-08-09T10:26:31.440Z',
        ValidFrom: '2023-08-09T10:26:31.440Z',
        ValidUpto: '2034-07-21T10:26:31.440Z',
        RevNo: 0,
    },
];

mock.onPost('/getPanelcatg/').reply(function (config) {
    return new Promise(function (resolve, reject) {
        setTimeout(function () {
            // get parameters from post request
            resolve([200, panelCategory]);
        }, 1000);
    });
});

mock.onPost('/getPanelCategoryDetail/').reply((config) => {
    const params = JSON.parse(config.data);
    const panelCategoryData = panelCategory.filter((item) => item.PanelCategID === params.id)[0];
    return [200, { ...panelCategoryData }];
});
